import React from 'react';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';

// The API sends the daily series alongside the summary figures; accept the
// obvious shapes so a rename on the backend does not blank the chart.
const readDailySeries = (summary) => {
  const daily =
    summary?.daily || summary?.trend || summary?.daily_stats || summary?.by_day;
  if (!Array.isArray(daily) || !daily.length) return [];
  return daily
    .map((point) => ({
      date: point?.date || point?.day || point?.order_date || '',
      failed: Number(point?.failed ?? point?.failed_count ?? point?.total ?? 0),
      converted: Number(point?.converted ?? point?.converted_count ?? 0),
    }))
    .filter((point) => point.date)
    .sort((a, b) => new Date(a.date) - new Date(b.date));
};

const PaymentFailedOrdersTrend = ({ summary }) => {
  const points = readDailySeries(summary);
  // Nothing to compare until at least one episode has been recovered
  const hasConversions =
    Number(summary?.converted ?? 0) > 0 ||
    points.some((point) => point.converted > 0);
  if (!points.length || !hasConversions) return null;

  const options = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'inherit',
    },
    colors: ['#e8590c', '#14653a'],
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    grid: { borderColor: '#f1f1f1' },
    markers: { size: 3 },
    legend: { position: 'top', horizontalAlign: 'right', fontSize: '12px' },
    xaxis: {
      categories: points.map((point) => moment(point.date).format('DD MMM')),
      labels: { style: { fontSize: '11px' } },
    },
    yaxis: {
      labels: {
        style: { fontSize: '11px' },
        formatter: (value) => Math.round(value),
      },
    },
    tooltip: { shared: true, intersect: false },
  };

  const series = [
    { name: 'Failed', data: points.map((point) => point.failed) },
    { name: 'Converted', data: points.map((point) => point.converted) },
  ];

  return (
    <div className="pf-kpi-card mb-3">
      <div className="pf-kpi-label mb-1">Daily failed vs converted</div>
      <ReactApexChart options={options} series={series} type="line" height={240} />
    </div>
  );
};

export default PaymentFailedOrdersTrend;
